<template>
  <div class="flex flex-col gap-2">
    <div v-for="(group, groupIndex) in roleGroups" :key="groupIndex" class="flex flex-col gap-0.5">
      <BaseCheckboxListItem
        v-for="role in group.roles"
        :key="role"
        :title="$t(`organization.roles.${role}`)"
        :selected="modelValue.includes(role)"
        :description="descriptionFor(role)"
        :is-radio="group.isExclusive && group.roles.length > 1"
        class="first:rounded-t-medium last:rounded-b-medium"
        :icon="iconForRole(role)"
        @click="toggleRole(role)"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import BaseCheckboxListItem from '@/core/components/base/list-item/BaseCheckboxListItem.vue'
  import {
    groupOrganizationRoles,
    iconForRole,
    toggleOrganizationRole,
    type Role,
  } from '@/modules/organization/models/organization-role'
  import {
    roleDescriptionKey,
    useOrganizationCapabilitySettings,
  } from '@/modules/settings/composables/use-organization-capability-settings'

  interface Props {
    availableRoles: ReadonlyArray<Role>
    modelValue: Role[]
  }

  const props = defineProps<Props>()

  const { t } = useI18n()
  const { settings } = useOrganizationCapabilitySettings()

  const descriptionFor = (role: Role) => t(roleDescriptionKey(role, settings.value))

  const emit = defineEmits<{
    (e: 'update:modelValue', roles: Role[]): void
  }>()

  const roleGroups = computed(() => groupOrganizationRoles(props.availableRoles))

  const toggleRole = (role: Role) => {
    emit('update:modelValue', toggleOrganizationRole(props.modelValue, role))
  }
</script>
